import { render, staticRenderFns } from "./app_privacy.vue?vue&type=template&id=725f9cc3&scoped=true&"
import script from "./app_privacy.vue?vue&type=script&lang=js&"
export * from "./app_privacy.vue?vue&type=script&lang=js&"
import style0 from "./app_privacy.vue?vue&type=style&index=0&id=725f9cc3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725f9cc3",
  null
  
)

export default component.exports